import request from "../../untils/request.js"


export const getReservationList = (params) => {
    return request.get("/outpatient/register/page", {params} )
}

export const getDeptInDoctorList = (params) => {
    return request.get("/outpatient/register/getDoctorPatient", {params} )
}

export const getMedicaltemplate = (params) => {
    return request.get("/outpatient/medicaltemplate/page", {params} )
}

export const getDugpurctcmtable = (params) => {
    return request.get("/outpatient/dugpurctcmtable/list", {params} )
}

export const getAiseList = (params) => {
    return request.get("/outpatient/aise/list", {params} )
}

export const getWesternMedicineRep = (params) => {
    return request.get("/outpatient/page", {params} )
}

export const getDrugList = (params) => {
    return request.get("/outpatient/getDrugList", {params} )
}

//西药诊断目录
export const getDocticdList = (params) => {
    return request.get("/outpatient/docticd/list", {params} )
}

export const getChinaDocticdList = (params) => {
    return request.get("/outpatient/tcmdise/listMenu", {params} )
}

//居民健康档案-信息列表
export const getDocphrList = (id) => {
    return request.get(`/outpatient/docphr/${id}`)
}

export const getChargingPriceById = (id) => {
    return request.get(`/outpatient/costnametable/${id}`)
}

//主诉模板分页
export const getComplainTemplate = (params) => {
    return request.get('/outpatient/complaintemplate/page',{params})
}

//现病史模板分页
export const getNowHistoryTemplate = (params) => {
    return request.get('/outpatient/nowsicknesstemplate/page',{params})
}

//既往史病历模板
export const getBeforeHistoryTemplate = (params) => {
    return request.get('/outpatient/historysicknesstemplate/page',{params})
}

//主诉模板新增
export const addComplainTemplate = (data) => {
    return request.post('/outpatient/complaintemplate',data)
}

//主诉模板修改
export const editComplainTemplate = (data) => {
    return request.put('/outpatient/complaintemplate',data)
}

//现病史模板新增
export const addNowHistoryTemplate = (data) => {
    return request.post('/outpatient/nowsicknesstemplate',data)
}

//现病史模板修改
export const editNowHistoryTemplate = (data) => {
    return request.put('/outpatient/nowsicknesstemplate',data)
}

//既往史模板新增
export const addBeforeHistoryTemplate = (data) => {
    return request.post('/outpatient/historysicknesstemplate',data)
}

//既往史模板修改
export const editBeforeHistoryTemplate = (data) => {
    return request.put('/outpatient/historysicknesstemplate',data)
}

//居民健康档案-信息列表
export const getDocphrByCondtion = (params) => {
    return request.get("/outpatient/docphr/list", { params } )
}

//居民健康档案-信息列表
export const checkClinicRelation = (params) => {
    return request.get("/outpatient/docphr/checkClinicRelation", { params } )
}

//快速就诊
export const addFastReception = (data) => {
    return request.post("/outpatient/seedoctor/quick", data )
}

//门诊就诊保存
export const addReception = (data) => {
    return request.post("/outpatient/seedoctor", data )
}

//门诊就诊保存
export const editReception = (data) => {
    return request.put("/outpatient/seedoctor", data )
}

//门诊就诊查询
export const getReceptionList = (params) => {
    return request.get("/outpatient/seedoctor/list", { params } )
}

//取消就诊
export const getReceptionCancel = (params) => {
    return request.get("/outpatient/seedoctor/cancel", { params } )
}

//查询单个挂号信息
export const getRegisterById = (params) => {
    return request.get("/outpatient/register/{id}", { params } )
}

//门诊就诊分页
export const getFinishReception = (params) => {
    return request.get("/outpatient/seedoctor/page", { params } )
}

export const getPatientPage = (params) => {
    return request.get("/outpatient/seedoctor/patientPage", { params } )
}

//诊断保存
export const editReceptionDiagnosis = (data) => {
    return request.post("/outpatient/seedoctor/editDiagnosis", data )
}

//获取诊断数据
export const getReceptionDiagnosis = (params) => {
    return request.get("/outpatient/seedoctor/getDiagnosis", { params } )
}

//中医证候目录全部
export const getSyndromeList = (params) => {
    return request.get("/outpatient/tcmsymp/listMenu", { params } )
}
//获取参数列表
export const getSystemList = () => {
    return request.get("/outpatient/system/list")
}
//中医证候目录查询
export const getSyndromeByCondition = (params) => {
    return request.get("/outpatient/tcmsymp/search", { params } )
}

//中医病症目录查询
export const getChinaDiseaseByCondition = (params) => {
    return request.get("/outpatient/tcmdise/search", { params } )
}

//西药库存列表
export const getDrugByCondition = (params) => {
    return request.get("/outpatient/dugdpurctable/list", { params } )
}

//中药库存列表
export const getChinaDugdpurctable = (params) => {
    return request.get("/outpatient/dugpurctcmtable/list", { params } )
}

//新增处置处方
export const addDoctordispose = (data) => {
    return request.post("/outpatient/doctordispose", data )
}

//修改处置处方
export const editDoctordispose = (data) => {
    return request.put("/outpatient/doctordispose", data )
}

//ceshi
export const getDoctordispose = (params) => {
    return request.get("/outpatient/doctordispose/list", { params } )
}

//ceshi
export const getDoctoradvice = (params) => {
    return request.get("/outpatient/doctoradvice/list", { params } )
}

//ceshi
export const getMedicationFrequency = (params) => {
    return request.get("/outpatient/getMedicationFrequency", { params } )
}


//西药库存列表
export const ceshi = (params) => {
    return request.get("/outpatient/selectAllDrugCategory", { params } )
}

//西药处方保存
export const addWestPrescription = (data) => {
    return request.post("/outpatient/rxmain", data )
}

//西药处方保存
export const editWestPrescription = (data) => {
    return request.put("/outpatient/rxmain", data )
}

//西药处方查询 根据就诊ID
export const getWestPrescriptionBySeeId = (params) => {
    return request.get("/outpatient/rxmain/getDetails", { params } )
}

//中药处方保存
export const addChinaPrescription = (data) => {
    return request.post("/outpatient/tcmrxmain", data )
}

//中药处方保存
export const editChinaPrescription = (data) => {
    return request.put("/outpatient/tcmrxmain", data )
}

//西药处方信息
export const getWestPrescription = (data) => {
    return request.get(`/outpatient/rxmain/${data}`)
}

//中药处方信息
export const getChinaPrescription = (params) => {
    return request.get('/outpatient/tcmrxmain/get',{params})
}


//删除处方
export const delOneAdvice = (params) => {
    return request.get('/outpatient/doctoradvice/delete',{params})
}

//删除处方
export const getPatientSeeDoctorData = (params) => {
    return request.get('/outpatient/seedoctor/get',{params})
}

//查询身份证是否存在
export const getDoesItExistSFZ = (params) => {
    return request.get('/outpatient/docphr/verifyCertNo',{params})
}

//包装单位
export const getDrugUnt = (params) => {
    return request.get('/outpatient/getDrugUnt',{params})
}

//获取诊疗信息打印数据
export const getDiagnosisInfo = (params) => {
    return request.get('/outpatient/seedoctor/getDiagnosisInfo',{params})
}

//获取诊疗信息打印数据
export const editDoctoradvice = (data) => {
    return request.post('/outpatient/doctoradvice/update',data)
}

//获取诊疗信息打印数据
export const printOutpatientsDerive = (params) => {
    return request.get('/outpatient/seedoctor/diagnosisInfoExport',{params,responseType: 'blob'})
}

//批量导出Excel就诊信息
export const batchDeriveExcelSeeDoctorData = (params) => {
    return request.get('/outpatient/seedoctor/diagnosisInfoExportBatch',{params,responseType: 'blob'})
}

//就诊信息导出
export const exportOfMedicalVisitRecords= (params) => {
    return request.get('/outpatient/seedoctor/export',{params,responseType: 'blob'})
}

//获取诊疗信息打印数据
export const getOneSeeDoctorData = (params) => {
    return request.get('/outpatient/seedoctor/get',{params})
}

//读取身份证信息
export const getCardnoIncludeData = (params) => {
    return request.get('http://localhost:8989/api/ReadMsg', { params });
};


//新增过敏原
export const addAise = (data) => {
    return request.post('/outpatient/aise', data);
};

//修改过敏原
export const editAise = (data) => {
    return request.put('/outpatient/aise', data);
};

//上传对象
export const uploadFile = (data) => {
    return request.post('/outpatient/upload/file', data);
};

//保存语音病历
export const addMedicalAudio = (data) => {
    return request.post('/outpatient/medicalAudio', data);
};

//查询语音列表
export const getMedicalAudioList = (params) => {
    return request.get('/outpatient/medicalAudio/list', {params});
};

//缓存实时存储
export const addMedicineCache = (data) => {
    return request.post('/outpatient/cache/save', data);
};

//缓存获取
export const getMedicineCache = (params) => {
    return request.get('/outpatient/cache/get', {params});
};

//获取患者所有信息
export const getPatientAllData = (params) => {
    return request.get('/outpatient/seedoctor/getAll', {params});
};

//获取患者所有信息
export const getDoctordisposeById = (id) => {
    return request.get(`/outpatient/doctordispose/${id}`);
};

//Ai开方
export const aiPrescribeSend = (data) => {
    return request.post('/outpatient/ai/send',data);
};
//居民健康档案-信息列表
export const getDocphrAllList = (params) => {
    return request.get("/outpatient/docphr/list", { params } )
}


//西药检查药品库存
export const checkWestDrug = (params) => {
    return request.get("/outpatient/dugdpurctable/check", { params } )
}

//中药检查药品库存
export const checkChinaDrug = (params) => {
    return request.get("/outpatient/dugpurctcmtable/check", { params } )
}

export const addOrders = (data) => {
    return request.post("/outpatient/api/v2/outpatient/orders",  data  )
}

// 修改接口 - PUT 请求
export function editOrders(orderId, data) {
    return request({
        url: `/outpatient/api/v2/outpatient/orders/${orderId}`,
        method: 'put',
        data: data
    });
}






export default{

}